<template>
  <div>
    <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
      <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
    </v-btn>
    <div id="document1" class="printdiv main" v-if="lc_data != null">
      <div class="ssc-line-height" style="padding: 5px; color: navy">
        <v-row style="margin-top: 155px; ">
          <v-col class="pt-5 pb-0 pl-12" cols="9" sm="9" md="9"> <strong>Sr.No.</strong> - {{ lc_data.certificate_no
            }}</v-col>
          <v-col class="pt-5 pb-0 pr-10" cols="3" sm="3" md="3" align="left">
            <strong>Gen.Reg.No</strong>  {{ lc_data.gr_number }}</v-col>
        </v-row>
      </div>
      <br>
      <div class="row ssc-matter mb-0 pb-0" style="color: navy; font-size: 17px; padding: 16px; margin-left: 20px;">
        <v-col cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>PEN</strong>  <span style="width: 491px">{{ lc_data.pen_no }}</span>
          </div>
        </v-col>
        <v-col cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>Aadhaar No.</strong> <span style="width: 236px">{{ lc_data.aadhar_no }}</span>
          </div>
        </v-col>
        <v-col cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>Apaar ID</strong>  <span style="width: 236px">{{ lc_data.apaar_id }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="9" sm="9" md="9">
          <div class="field-container">
            <strong>Student's First Name</strong>  <span style="width: 150px">{{ lc_data.first_name }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="9" sm="9" md="9">
          <div class="field-container">
            <strong>Father's Name</strong><span style="width: 204px">{{ lc_data.middle_name }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="9" sm="9" md="9">
          <div class="field-container">
            <strong>Surname</strong>  <span style="width: 240px">{{ lc_data.last_name }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="9" sm="9" md="9">
          <div class="field-container">
            <strong>Mother's Name</strong>  <span style="width: 189px">{{ lc_data.mother_first_name }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="4" sm="4" md="4">
          <div class="field-container">
            <strong> Mother Tongue </strong> <span style="width: 195px">{{ lc_data.mothertoungue }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>Religion</strong>  <span style="width: 250px">{{ lc_data.religion }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>Nationality</strong>  <span style="width: 229px">{{ lc_data.nationality }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>Caste</strong><span style="width: 265px">{{ lc_data.caste }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>Sub Caste</strong>  <span style="width: 230px">{{ lc_data.subcaste }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="9" sm="9" md="9">
          <div class="field-container">
            <strong>Birth Place/City</strong> <span style="width: 280px">{{ lc_data.birth_place }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="9" sm="9" md="9">
          <div class="field-container">
            <strong> Taluka</strong> <span style="width: 280px">{{ lc_data.birth_taluka }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>Dist</strong>  <span style="width: 354px">{{ lc_data.birth_district }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>State</strong> <span style="width: 354px">{{ lc_data.birth_state }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="4" sm="4" md="4">
          <div class="field-container">
            <strong>Country</strong> <span style="width: 505px">{{ lc_data.birth_country }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="12" sm="12" md="12">
          <div class="field-container">
            <strong>Date of Birth as per Christian Era</strong> <span style="width: 760px">{{ lc_data.dob_fig
              }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="12" sm="12" md="12">
          <div class="field-container">
            <strong>Date of Birth in Words</strong>  <span style="width: 838px">{{ lc_data.dob_words }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="12" sm="12" md="12">
          <div class="field-container">
            <strong>Name of the Previous School & Std</strong>  <span style="width: 742px">{{ lc_data.last_school }}
              Std. {{ lc_data.previousschoolpassingstandard }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="6" sm="6" md="6">
          <div class="field-container">
            <strong>Date of Admission</strong> <span style="width: 347px">{{ lc_data.doa }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="6" sm="6" md="6">
          <div class="field-container">
            <strong>Std.</strong>  <span style="width: 447px">{{ lc_data.standard }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="6" sm="6" md="6">
          <div class="field-container">
            <strong> Progress in Study</strong> <span style="width: 352px">{{ lc_data.progress }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="6" sm="6" md="6">
          <div class="field-container">
            <strong>Behaviour</strong>  <span style="width: 405px">{{ lc_data.conduct }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="12" sm="12" md="12">
          <div class="field-container">
            <strong>Date of Leaving School</strong>  <span style="width: 828px">{{ lc_data.last_date_of_school
              }}</span>
          </div>
        </v-col>
        <v-col class="pt-0 mb-5" cols="12" sm="12" md="12">
          <div class="field-container">
            <strong>Std. in which studying & since when (Both in words & figures)</strong>  <span
              style="width: 552px">{{ lc_data.std_in_words }} since {{ lc_data.standard_since_when }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="12" sm="12" md="12">
          <div class="field-container">
            <strong>Reason of Leaving School</strong> <span style="width: 809px">{{ lc_data.reason }}</span>
          </div>
        </v-col>
        <v-col class="pt-0" cols="12" sm="12" md="12">
          <div class="field-container">
            <strong>Remark</strong>  <span style="width: 937px">{{ lc_data.remark }}</span>
          </div>
        </v-col>
      </div>
      <br />
      <div style="color: navy; padding-bottom: 2px;  padding: 12px; padding-left: 50px; font-size: medium;">
        <strong> Certified that above mentioned information is true according to the
          school General Register No. 1</strong>
      </div>
      <span style="color: navy;    padding: 15px; padding-left: 50px;"> <strong>Date </strong> {{ lc_data.date_of_issue }}</span>
      <v-row class="ssc-last-row">
        <v-col cols="4" sm="4" md="4" align="center"><b>CLASS TEACHER</b></v-col>
        <v-col cols="4" sm="4" md="4" align="center"><b>CLERK</b></v-col>
        <v-col cols="4" sm="4" md="4" align="center"><b>PRINCIPAL</b></v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css";
  export default {
    data() {
      return {
        lc_data: null,
        org_basic_data: null,
        org_id: null,
      };
    },
    methods: {
      print() {
        this.$store.state.drawer = false;
        let that = this;
        window.onafterprint = function () {
          that.$store.state.drawer = true;
        };
        setTimeout(function () {
          window.print();
        }, 100);
      },
    },
    mounted() {
      this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
      this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
    },
  };
</script>
<style scoped>
  tr,
  td,
  th {
    text-align: center;
    font-size: small;
  }

  tr,
  tbody {
    font-size: small;
  }

  td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
  }

  /* lc data css */
  .printdiv {
    height: auto;
    margin-left: 15%;
    margin-right: 15%;
    background-color: rgb(248, 248, 241);
    background-position: center;
  }

  .gradient-heading {
    background-image: linear-gradient(to bottom, #ec407a, #4a148c);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    font-family: "Times New Roman", Times, serif;
    margin-bottom: 15px;
  }

  .main {
    padding: 20px;
  }

  .field-container {
    display: flex;
    align-items: baseline;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .field-container strong::after {
    content: " - ";
    margin: 0 4px;
  }

  .bottom-line {
    border-bottom: 1px solid;
    display: inline-block;
    padding-bottom: 1px;
    margin-left: 5px;
  }

  .header {
    margin: 6px;
  }

  .tdata2 {
    font-weight: bolder;
  }

  p {
    font-size: medium;
    margin: 0;
    font-weight: 600;
  }

  h1 {
    color: rgb(235, 61, 61);
  }

  .ssc-last-row {
    color: #1b5e20;
    margin-top:45px;
    margin-bottom: 10px;
  }

  /* lc data css end */

  /* print lc css */
  @media print {
    .pagebreak {
      page-break-before: always;
    }

    header,
    footer,
    nav,
    date {
      display: none !important;
    }

    body,
    tr,
    th,
    td {
      font-size: 17px !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
      display: none !important;
    }

    v-card {
      border: none !important;
    }

    .printdiv {
      margin: 0;
      padding: 0;
    }

    #document1 {
      position: absolute;
      top: 0;
      bottom: 0;
    }

    .text-color {
      padding: 10px !important;
      margin-left: -10px;
    }

    .main {
      width: 100%;
      padding: 3px;
      font-size: 17px !important;
    }

    .field-container {
      display: flex !important;
      align-items: baseline !important;
      flex-wrap: nowrap !important;
      white-space: nowrap !important;
    }

    .bottom-line {
      border-bottom: 1px solid !important;
      display: inline-block !important;
      padding-bottom: 1px !important;
      margin-left: 5px !important;
    }

    .ssc-matter {
      line-height: 120% !important;
    }

    .ssc-line-height {
      line-height: 100%;
    }

    .ssc-last-row {
      margin-top: 50px !important;
    }

    .gradient-heading {
      font-size: 40px;
    }

    @page {
      size: A4;
      margin: 2mm;
    }
  }

  /* print lc css end */
</style>